import Fieldset from "@/components/Fieldset";
import { DurationKamField } from "@/modules/projects/components/schedules/fields/DurationKamField";
import { DurationPrField } from "@/modules/projects/components/schedules/fields/DurationPrField";
import { TimeRangeField } from "@/modules/projects/components/schedules/fields/TimeRangeField";
import { memo } from "react";

interface ProjectSchedulesVisitFormProps {
  prPlannedDuration?: string | null;
  disabled?: boolean;
}

const ProjectSchedulesVisitFormComponent = ({
  prPlannedDuration,
  disabled = false,
}: ProjectSchedulesVisitFormProps) => {
  return (
    <>
      <Fieldset className="flex flex-row gap-4 m-0 items-start">
        <div className="flex-shrink-0">
          <TimeRangeField disabled={disabled} />
        </div>
        <div className="flex flex-row gap-4 flex-[2] min-w-[500px]">
          <DurationKamField disabled={disabled} />
          <DurationPrField prPlannedDuration={prPlannedDuration} />
        </div>
      </Fieldset>
    </>
  );
};

export const ProjectSchedulesVisitForm = memo(
  ProjectSchedulesVisitFormComponent,
);
